module.exports = __webpack_public_path__ + "img/标题文字_服务案例.aba6739e.svg";